// contact-origin.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactOriginService {
  private origin = '';

  setOrigin(value: string) {
    this.origin = value;
  }

  getOrigin() {
    return this.origin;
  }
}
